import router from '../router/templateOne'
import { checkURLsToMountByRouter } from './AppMountHelpers'

// for theme 2
export default async function checkURLsToMount () {
  return checkURLsToMountByRouter(router, 1)
}
